import {postMethod} from '~/api'

async function post(request) {
    return await postMethod('/api/fillCruiseBookingData', request)
}

export {post}
